module.exports = __webpack_public_path__ + "static/media/evacuation-bg1.02b36bd1.png";